import dayjs from '@srm/ui/lib/dayjs';
import { parseRuDate, parseRuDateTime } from '@utils/date';
import { toLocalDate } from '@srm/ui/lib/toLocalDate';
import { ValueType } from '@srm/ui/types/ValueType';
import { exportDataTableToExcel } from '@srm/ui/data-table/excel';
import { IAttachColumn, IAttachRow } from './AttachGrid.types';
import { rowValue } from './attachRowView';

const isDateType = (dt: ValueType): boolean =>
    dt === ValueType.Date || dt === ValueType.DateTime || dt === ValueType.NoSecDateTime;

/** Текст ячейки для Excel: даты приводим к `DD.MM.YYYY HH:mm`, остальное — как есть. */
function cellText(column: IAttachColumn, row: IAttachRow): string {
    const value = rowValue(row, column.field);
    if (value == null || value === '') return '';
    if (isDateType(column.dataType)) {
        const s = String(value);
        const ru = parseRuDateTime(s) ?? parseRuDate(s);
        const d = ru ? dayjs(ru) : dayjs(toLocalDate(value as Date | string | number));
        return d.isValid() ? d.format('DD.MM.YYYY HH:mm') : s;
    }
    return String(value);
}

/** Клиентский экспорт текущего (отфильтрованного/отсортированного) набора в .xlsx.
 *  Сборка файла — общим экспортом базовой таблицы: один код форматирования книги. */
export async function exportAttachesToExcel(
    rows: IAttachRow[],
    columns: IAttachColumn[],
    fileName: string,
): Promise<void> {
    const visible = columns.filter((c) => c.show);
    await exportDataTableToExcel({
        fileName,
        sheetName: 'Вложения',
        headers: visible.map((c) => c.header),
        rows: rows.map((row) => visible.map((c) => cellText(c, row))),
    });
}
